import React from 'react'
import ReactDOM from 'react-dom'
import 'scss/index.css';
import App from './App';
import { createStore, combineReducers, applyMiddleware } from 'redux'
import createHistory from 'history/createBrowserHistory'
import { connect, Provider } from 'react-redux'
import { Route, Switch } from 'react-router'
import { Redirect } from 'react-router-dom'
import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux'
import * as reducers from './redux/reducers'
import registerServiceWorker from './registerServiceWorker';
import {connection,dataStore} from './redux/middleware';
import { LocaleProvider } from 'antd';
import jaJP from 'antd/lib/locale-provider/ja_JP';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory()

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(
    combineReducers({
        ...reducers,
        router: routerReducer
    }),
    applyMiddleware(middleware,connection,dataStore)
);

ReactDOM.render(
    <Provider store={store}>
        <LocaleProvider locale={jaJP}>
            <div>
                { /* ConnectedRouter will use the store from Provider automatically */ }
                <ConnectedRouter history={history} basename={'/map'}>
                    <Switch>
                        <Route path={process.env.PUBLIC_URL}  component={App} />
                    </Switch>
                </ConnectedRouter>
            </div>
        </LocaleProvider>
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js